import { NextRequest, NextResponse } from 'next/server'
import { getDevMagicLink } from '@/lib/dev-magic-link'

export async function GET(request: NextRequest) {
  if (process.env.NODE_ENV === 'production') {
    return NextResponse.json({ error: 'Not found' }, { status: 404 })
  }

  const email = request.nextUrl.searchParams.get('email')?.trim()
  if (!email) return NextResponse.json({ error: 'email is required' }, { status: 400 })

  const link = getDevMagicLink(email)
  if (!link) return NextResponse.json({ link: null })

  return NextResponse.json({
    link: {
      url: link.url,
      expires: link.expires.toISOString(),
      createdAt: link.createdAt.toISOString(),
    },
  })
}
